import { useEffect, useState } from 'react';
import { crmApi } from '../../api/crm.js';
import { useAuth } from '../../contexts/AuthContext.jsx';

export default function Companies() {
  const { can } = useAuth();
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState('');
  const [showForm, setShowForm] = useState(false);

  function refresh() { crmApi.companies({ search }).then((d) => setItems(d?.items || [])); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, [search]);

  async function submit(e) {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    await crmApi.createCompany({
      name: fd.get('name'),
      industry: fd.get('industry') || null,
      size: fd.get('size') || null,
      website: fd.get('website') || null,
    });
    e.currentTarget.reset();
    setShowForm(false);
    refresh();
  }

  return (
    <section>
      <header className="page-header">
        <h1>Companies</h1>
        {can('company', 'create') && <button className="btn primary" onClick={() => setShowForm((s) => !s)}>{showForm ? 'Close' : '+ New Company'}</button>}
      </header>
      {showForm && (
        <form onSubmit={submit} className="card form-card grid-form">
          <label>Name<input name="name" required /></label>
          <label>Industry<input name="industry" /></label>
          <label>Size<input name="size" placeholder="e.g. 50-200" /></label>
          <label>Website<input name="website" /></label>
          <div className="full actions"><button className="btn primary" type="submit">Create</button></div>
        </form>
      )}
      <div className="card form-card grid-form">
        <label className="full">Search<input value={search} onChange={(e) => setSearch(e.target.value)} /></label>
      </div>
      <div className="card">
        <table className="data-table">
          <thead><tr><th>Name</th><th>Industry</th><th>Size</th><th>Website</th></tr></thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id}>
                <td><strong>{c.name}</strong></td>
                <td className="muted">{c.industry || '—'}</td>
                <td className="muted">{c.size || '—'}</td>
                <td>{c.website ? <a href={c.website.startsWith('http') ? c.website : `https://${c.website}`} target="_blank" rel="noreferrer">{c.website}</a> : '—'}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={4} className="muted">No companies yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
